export default "__VITE_ASSET__BIaUgoVN__"